export default __webpack_public_path__ + "static/media/logo512.7c04a0be.png";